export default class StaticdeployClientError extends Error {
    constructor(message, originalError) {
        super(message);
        this.originalError = originalError;
    }
}
//# sourceMappingURL=StaticdeployClientError.js.map